import { LABELS } from '@/constants/common/message.constants'

import { type CargoAreaEquipmentEntity } from '../..'

/**
 * 荷台装備種別
 */
export type CargoAreaEquipmentType = Exclude<
  CargoAreaEquipmentEntity['type'],
  null
>

export const CARGO_AREA_EQUIPMENT_TYPE = {
  /** 緩衝材 */
  CUSHIONING_MATERIAL: 'CUSHIONING_MATERIAL',
  /** コンパネ */
  CONCRETE_PANEL: 'CONCRETE_PANEL',
  /** ラッシング (サイド) */
  LASHING_SIDE: 'LASHING_SIDE',
  /** ラッシング (床) */
  LASHING_FLOOR: 'LASHING_FLOOR',
  /** ラップ */
  WRAPPING_MATERIAL: 'WRAPPING_MATERIAL',
  /** リンギ */
  RINGI: 'RINGI',
  /** 通しリンギ */
  THROUGH_RINGI: 'THROUGH_RINGI',
  /** ワイヤー */
  WIRE: 'WIRE',
  /** レバーブロック */
  LEVER_BLOCK: 'LEVER_BLOCK',
  /** ロープ */
  ROPE: 'ROPE',
  /** 大シート */
  LARGE_SHEET: 'LARGE_SHEET',
  /** 中シート */
  MEDIUM_SHEET: 'MEDIUM_SHEET',
  /** 平掛けシート */
  FLAT_COVER_SHEET: 'FLAT_COVER_SHEET',
  /** 下敷きシート (ブルーシート) */
  UNDERLAYMENT_SHEET: 'UNDERLAYMENT_SHEET'
} as const satisfies Record<CargoAreaEquipmentType, CargoAreaEquipmentType>

export const CARGO_AREA_EQUIPMENT_TYPE_LABEL = {
  [CARGO_AREA_EQUIPMENT_TYPE.CUSHIONING_MATERIAL]: LABELS.CUSHIONING_MATERIAL,
  [CARGO_AREA_EQUIPMENT_TYPE.CONCRETE_PANEL]: LABELS.CONCRETE_PANEL,
  [CARGO_AREA_EQUIPMENT_TYPE.LASHING_SIDE]: LABELS.LASHING_SIDE,
  [CARGO_AREA_EQUIPMENT_TYPE.LASHING_FLOOR]: LABELS.LASHING_FLOOR,
  [CARGO_AREA_EQUIPMENT_TYPE.WRAPPING_MATERIAL]: LABELS.WRAPPING_MATERIAL,
  [CARGO_AREA_EQUIPMENT_TYPE.RINGI]: LABELS.RINGI,
  [CARGO_AREA_EQUIPMENT_TYPE.THROUGH_RINGI]: LABELS.THROUGH_RINGI,
  [CARGO_AREA_EQUIPMENT_TYPE.WIRE]: LABELS.WIRE,
  [CARGO_AREA_EQUIPMENT_TYPE.LEVER_BLOCK]: LABELS.LEVER_BLOCK,
  [CARGO_AREA_EQUIPMENT_TYPE.ROPE]: LABELS.ROPE,
  [CARGO_AREA_EQUIPMENT_TYPE.LARGE_SHEET]: LABELS.LARGE_SHEET,
  [CARGO_AREA_EQUIPMENT_TYPE.MEDIUM_SHEET]: LABELS.MEDIUM_SHEET,
  [CARGO_AREA_EQUIPMENT_TYPE.FLAT_COVER_SHEET]: LABELS.FLAT_COVER_SHEET,
  [CARGO_AREA_EQUIPMENT_TYPE.UNDERLAYMENT_SHEET]: LABELS.UNDERLAYMENT_SHEET
} as const satisfies Record<CargoAreaEquipmentType, string>
